import { Icon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useCallback, useState } from 'react';
import ReleaseIcon from 'assets/icons/ReleaseIcon';
import { useAuthProtectedAction } from 'services/hooks/user';
import { StyledBox, StyledSubtitleWrapper, StyledTitle } from './styled';
import NewReleaseModalFlow from './NewReleaseModalFlow';
import useTrackClick from './useTrackClick';

const DistributeMusicTile = () => {
  const { t } = useTranslation();
  const [isNewReleaseModalOpen, setIsNewReleaseModalOpen] = useState(false);

  const tileTitle = t('discoveryPage:headerTiles:titles:distributeMusic');
  const handleTrackClick = useTrackClick(tileTitle);

  const memoizedSetIsNewReleaseModalOpen = useCallback(() => {
    setIsNewReleaseModalOpen(true);
  }, [setIsNewReleaseModalOpen]);

  const protectedOpenModal = useAuthProtectedAction(
    memoizedSetIsNewReleaseModalOpen
  );

  const handleNewReleaseClick = useCallback(() => {
    protectedOpenModal();
    handleTrackClick();
  }, [protectedOpenModal, handleTrackClick]);

  const handleNewReleaseModalClose = () => setIsNewReleaseModalOpen(false);

  return (
    <>
      <StyledBox onClick={handleNewReleaseClick}>
        <Icon color="secondary">
          <ReleaseIcon />
        </Icon>
        <StyledTitle>{tileTitle}</StyledTitle>
        <StyledSubtitleWrapper>
          <Typography>
            {t('discoveryPage:headerTiles:subtitle:createNewRelease')}
          </Typography>
          <KeyboardArrowRightIcon className="arrow-right" />
        </StyledSubtitleWrapper>
      </StyledBox>
      <NewReleaseModalFlow
        isOpen={isNewReleaseModalOpen}
        onClose={handleNewReleaseModalClose}
      />
    </>
  );
};

export default DistributeMusicTile;
